<template>


<div>
  <FieldLabel v-if="showFieldHelp" :label="item.name" :help="fieldHelp" :input-id="fieldInputId" :field-id="item.id" :modal-key="modalKey" />
  <div class="field-text">

  <v-tooltip v-if="showTranslationAction" top>
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">
        <v-btn class="field-text__translation-button" icon small color="indigo" :disabled="!canTranslate" @click="translationDialog = true"><v-icon>mdi-earth</v-icon></v-btn>
      </span>
    </template>
    <span>{{ canTranslate ? 'Gérer les traductions' : "Enregistrez d'abord la fiche pour ajouter des traductions" }}</span>
  </v-tooltip>


  <v-menu  v-model="menu" top nudge-bottom="23" nudge-left="0" :close-on-content-click="false" v-if="items && items.length">
            <template v-slot:activator="{ on }">
              <v-btn class="field-text__list-button secondary" v-on="on" small dark icon><v-icon>mdi mdi-list-box-outline</v-icon></v-btn>
            </template>
            <v-card>
              <v-card-text class="pa-0">

                      <Table
                      :Headers="[{text:'selectionnez votre choix',value:'text'}]"
                      :datas="items"
                      :isDraggable="false"
                      :editTable="selRow"
                      :del="false"
                      :hidesearch="false"
                      :hidefooter="false"
                      />

              </v-card-text>
            </v-card>
          </v-menu>

          <v-text-field
            ref="input"
            
            :id="fieldInputId"
            :label="showFieldHelp ? undefined : item.name"
            :aria-label="item.name"
            v-model="model"
            @keyup="handleKeyup"
            :name="item.value"
            :type="item.format"
            
            :rules="prop.modelRules"
            v-if="item.format!='number' && prop.show"
            :outlined="prop.outlined"
            :filled="prop.filled"
            :solo="prop.solo"
            :hint="prop.description"
            :placeholder="prop.placeholder"
            :persistent-hint="prop.persistenthint"
            :disabled="prop.disabled"
            :class="['field-text__input', prop.class]"
            :clearable="prop.clearable"
            :color="prop.coloronselect"
            @click:clear="keyup(item,'')"

            :prepend-icon="(prop.iconlr=='prepend' && prop.iconinout=='out') ? prop.iconmdi : ''"
            :prepend-inner-icon="(prop.iconlr=='prepend' && prop.iconinout!='out') ? prop.iconmdi : ''"
            :append-icon="(prop.iconlr=='append' && prop.iconinout!='out') ? prop.iconmdi : ''"
            :append-outer-icon="(prop.iconlr=='append' && prop.iconinout=='out') ? prop.iconmdi : ''"            

          ></v-text-field>    

          <v-text-field
            ref="input"
            
            :id="fieldInputId"
            :label="showFieldHelp ? undefined : item.name"
            :aria-label="item.name"
            v-model.number="model"
            @keyup="handleKeyup"
            :name="item.value"
            :type="item.format"

            :rules="prop.modelRules"
            v-if="item.format=='number' && prop.show"
            :outlined="prop.outlined"
            :filled="prop.filled"
            :solo="prop.solo"
            :hint="prop.description"
            :placeholder="prop.placeholder"
            :persistent-hint="prop.persistenthint"
            :disabled="prop.disabled"
            :class="['field-text__input', prop.class]"
            :clearable="prop.clearable"
            :color="prop.coloronselect"

            :prepend-icon="(prop.iconlr=='prepend' && prop.iconinout=='out') ? prop.iconmdi : ''"
            :prepend-inner-icon="(prop.iconlr=='prepend' && prop.iconinout!='out') ? prop.iconmdi : ''"
            :append-icon="(prop.iconlr=='append' && prop.iconinout!='out') ? prop.iconmdi : ''"
            :append-outer-icon="(prop.iconlr=='append' && prop.iconinout=='out') ? prop.iconmdi : ''" 
          ></v-text-field>

          <FieldTranslationsDialog
            v-if="showTranslationAction && canTranslate"
            v-model="translationDialog"
           :field-id="item.id"
            :line-id="translationLineId"
            :field-name="item.name"
            :source-value="model"
          />
</div>
</div>
</template>



<script>
import mixinFields from '../../mixins/Fields'
import mixinConditionsFields from '../../mixins/conditionsFields'

import Table from '../engine/outils/simpleTable'  
import FieldTranslationsDialog from './FieldTranslationsDialog'

    export default {
        name : 'TextField',

        mixins : [mixinFields,mixinConditionsFields],

        components : {
                Table,
                FieldTranslationsDialog,
            },  

        data: function() {
            return { 
              menu : false,
              translationDialog: false,
              selRow : [{icon:'mdi-import',action:(item)=>{this.selectItem(item)}}]
            }
        },

        computed: {
          showTranslationAction() { return this.type === 'form' && this.item.isTranslatable === true },
          translationLineId() { return this.params && this.params.id },
          canTranslate() {
            return this.translationLineId !== undefined && this.translationLineId !== null && this.translationLineId !== '' && this.translationLineId !== 'new'
          }
        },

        methods : {

          handleKeyup(event) {
                this.keyup(this.item, this.model, event.key === 'Enter');
                this.$nextTick(() => {
                    if (this.$refs.input) this.$refs.input.validate();
                });
          },

          selectItem(item) {
                this.onSelect  = true
                let defaultKey = item.default;
                this.keyup(this.item,item[defaultKey],false);
                this.model = item[defaultKey]
                this.menu = false;
            }

        },

    }

</script>

<style scoped>
.field-text {
  display: flex;
  align-items: flex-start;
  width: 100%;
  min-width: 0;
}

.field-text__list-button {
  flex: 0 0 auto;
  margin: 4px 8px 0 0;
}

.field-text__translation-button {
  flex: 0 0 auto;
  margin: 4px 8px 0 0;
}

.field-text__input {
  flex: 1 1 auto;
  min-width: 0;
}
</style>
